<template>
	<v-dialog
		v-model="dialog"
		max-width="700"
		fullscreen
	>
		<!-- :fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''" -->
		<template v-slot:activator="{ on, attrs }">
			<v-btn v-if="myPageBtn" text @click.stop="openMyPageDialog" v-bind="attrs" v-on="on"
				>メッセージ作成</v-btn
			>
			<v-btn
				v-else
				:text="text"
				:color="'primary'"
				class="ml-2"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-message-plus-outline</v-icon>
				メッセージ作成
			</v-btn>
		</template>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">メッセージ作成</v-app-bar-title>
				<v-spacer />

				<v-btn icon dark @click=";(dialog = false), resetForm()" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>

			<v-form ref="form" class="form" lazy-validation>
				<v-container>
					<v-select
						v-model="message.selectedMessageTemplateId"
						label="テンプレート"
						hint="テンプレートを選択してください"
						class="mt-4"
						outlined
						required
						dense
						:items="message_templates"
						item-text="name"
						item-value="id"
						@change="selectType"
						clearable
					>
					</v-select>

					<v-select
						v-model="message.selectedDepartmentId"
						:rules="[rules.required]"
						label="送信先部署(必須)"
						hint="送信先部署を選択してください"
						class="mt-4"
						outlined
						required
						dense
						:items="departments"
						item-text="name"
						item-value="id"
						@change="setUsers"
						clearable
					>
					</v-select>

					<v-select
						v-model="message.selectedUser"
						:rules="[rules.required]"
						label="送信先社員(必須)"
						hint="送信先社員を選択してください"
						class="mt-4"
						outlined
						required
						dense
						:items="users"
						item-text="full_name"
						item-value="id"
						no-data-text="先に送信先部署を選択してください"
						clearable
					>
					</v-select>

					<v-text-field
						v-model="message.title"
						:rules="[rules.required]"
						class="mt-4"
						label="タイトル(必須)"
						outlined
						dense
					></v-text-field>

					<v-textarea
						v-model.trim="message.content"
						class="mt-4"
						label="内容"
						outlined
						dense
					></v-textarea>

					<!-- <v-select
						v-model="message.selectedRequirementTypeId"
						label="依頼の種類"
						class="mt-4"
						hint="依頼の種類を選択してください"
						outlined
						dense
						:items="requirement_types"
						item-text="name"
						item-value="id"
					>
					</v-select> -->

					<v-combobox
						ref="combobox"
						label="案件を探す"
						item-text="name"
						item-value="id"
						:hint="matterHint"
						class="mt-4"
						outlined
						dense
						v-model="message.matter"
						@keyup="setSearchMatters"
						@change="changeMatter"
						:items="matters"
						single
						small-chips
					/>

					<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
						<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
						添付ファイルを追加
						<input
							type="file"
							class="d-none"
							ref="uploadFile"
							@change="addFiles($event)"
							multiple
						/>
					</v-btn>

					<div class="file-area mt-2">
						<span v-if="allFiles < 1" class="filename">選択されていません</span>
						<template v-else>
							<v-chip
								class="ma-1 mt-2"
								close
								label
								outlined
								color="primary"
								@click:close="removeFile(i)"
								v-for="(file, i) in files"
								:key="file.name"
							>
								<v-icon class="mr-1">mdi-paperclip</v-icon>
								{{ file.name }}
							</v-chip>
						</template>
					</div>
				</v-container>
			</v-form>
			<v-card-actions class="pa-0">
				<v-row class="my-4" no-gutters justify="center">
					<v-btn
						class="ma-1 white--text font-weight-bold"
						@click="sendMessage"
						:disabled="!isValid"
						dense
						color="secondary"
					>
						<v-icon class="mr-1">mdi-send</v-icon>
						送信する</v-btn
					>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import rules from "../../../helper/rules"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"

export default {
	props: {
		text: Boolean,
		message: {
			type: Object,
			required: false,
			default: () => {},
		},
		message_templates: {
			type: Array,
			required: false,
			default: () => [],
		},
		departments: {
			type: Array,
			required: false,
			default: () => [],
		},
		requirement_types: {
			type: Array,
			required: false,
			default: () => [],
		},
		myPageBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			rules,
			type: "message",
			matters: [],
			users: [],
			requirements: [],
			dialog: false,
			errorMessageFlag: false,
			matterErrorMessages: [],
			searchMattersTimer: null,
			matterKeyword: null,
			files: [],
		}
	},
	methods: {
		resetForm() {
			this.files = []
			this.$refs.form.reset()
			this.$refs.combobox.reset()
		},
		removeFile(index) {
			this.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		sendMessage() {
			var formData = new FormData()

			formData.set("message[title]", this.message.title)
			formData.set("message[content]", this.message.content)
			formData.set("message[responder_id]", this.message.selectedUser)
			formData.set("type", this.type)
			if (this.message.matter) {
				formData.set("message[matter_id]", this.message.matter.id)
			}
			if (this.message.selectedRequirementTypeId) {
				formData.set("message[requirement_type_id]", this.message.selectedRequirementTypeId)
			}

			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"message[files]" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}

			const headers = authenticate.setHeader()
			axios
				.post("/erp/v1/messages", formData, { headers })
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "メッセージを送信しました。",
					})
					this.resetForm()
					this.dialog = false
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
		openMyPageDialog() {
			if (this.requirement_types.length) return (this.dialog = true)
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/messages/new", { headers })
				.then((res) => {
					this.$emit("message-new-data", res.data)
					this.dialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
					this.dialog = false
				})
		},
		selectType(id) {
			const message_template = this.message_templates.find(
				(message_templates) => message_templates.id == id
			)
			if (message_template) {
				this.message.content = message_template.fixed_form_sentences
			}
		},
		changeMatter() {
			// テキスト追加時の削除
			if (!this.matters.includes(this.message.matter)) {
				this.errorMessageFlag = true
				this.message.matter = null
				this.$refs.combobox.reset()
			}
		},
		setSearchMatters(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.matters = []
			this.matterKeyword = e.target.value
			clearTimeout(this.searchMattersTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.matterKeyword.length) return // 0文字の場合はreturn
			this.searchMattersTimer = setTimeout(this.fetchMatters, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		fetchMatters() {
			const params = {
				q: {
					name_or_quotation_number_cont: this.matterKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/matter_search", {
					headers,
					params,
				})
				.then((res) => {
					this.searchMattersTimer = null
					this.matters = res.data.matters
					this.errorMessageFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setUsers() {
			const department = this.departments.find(
				(department) => department.id == this.message.selectedDepartmentId
			)
			if (department) {
				this.users = department.users
			}
		},
		changeImage(file) {
			this.message.fileData = new Object()
			if (file == null) {
				return
			}
			this.message.fileData.type = file.type
			this.message.fileData.fileName = file.name

			this.readFileAsync(file)
				.then((res) => {
					this.message.fileData.data = res
				})
				.catch((e) => {
					this.$store.commit("setFlash", {
						type: "alert",
						text: "ファイルの読み込みに失敗しました",
					})
				})
		},
		readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					resolve(reader.result)
				}
				reader.onerror = reject
				reader.readAsArrayBuffer(file)
			})
		},
		isPresence(value) {
			return value !== null && value !== ""
		},
	},

	computed: {
		allFiles() {
			return this.files.length
		},
		matterHint() {
			if (this.matters.length) {
				return "案件を選択してください"
			} else if (this.searchMattersTimer) {
				return "案件を取得しています"
			} else if (!this.matters.length && this.matterKeyword) {
				return "該当する案件が存在していません"
			} else if (this.errorMessageFlag && !this.matterKeyword) {
				return "選択肢から案件を選択してください"
			} else {
				return "案件名、または、見積番号を入力してください"
			}
		},
		isValid() {
			if (
				this.isPresence(this.message.selectedUser) &&
				this.isPresence(this.message.title) &&
				this.isPresence(this.message.responder_id)
			) {
				return true
			} else {
				return false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.set-btn {
	padding: 8px;
	margin: 8px;
	border-radius: 3px;
	color: white;
	background-color: $main-color;
	min-width: 200px;
	box-shadow: 2px 2px 2px gray;
}
</style>
